const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página para realizar el PACK de una orden',
  PAGE_DESCRIPTION:
    'En este apartado puedes realizar todo el proceso para el PACK de una orden.'
};

export default HELPER_TEXTS;
